import React from 'react';

interface PortalGuardProps {
  children: React.ReactNode;
}

const PortalGuard: React.FC<PortalGuardProps> = ({ children }) => {
  // Portal is now open to all authenticated users
  // No beta restriction needed - user is already authenticated if they got here

  return <>{children}</>;
};

export default PortalGuard;
